module.exports = __webpack_public_path__ + "static/bro7-8437c90900f591134d3854a8e5356269.jpg";